import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the FilterBonusReportView.
 * @extends JetView
 */
export default class FilterBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with date and bonus type selectors
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting result date type
                    name: 'ResultDate',
                    localId: 'timeTypes:combo',
                    label: _('Tipo de tiempo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
                {
                    view: 'richselect', // Dropdown for selecting bonus type
                    name: 'BonusType',
                    localId: 'bonusTypes:combo',
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [],
                },
            ],
        };

        // Center left section with date picker and acceptance type selector
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Make input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'richselect', // Dropdown for selecting acceptance type
                    name: 'AcceptanceType',
                    localId: 'bonusStates:combo',
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [],
                },
            ],
        };

        // Center right section with client bonus ID input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for client bonus ID
                    name: 'ClientBonusId',
                    type: 'number', // Input type is number
                    label: _('Partner Bono Id'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Partner Bono Id'),
                    invalidMessage: _('Partner Bonus Id is required'), // Validation message
                },
            ],
        };

        // Right section with partner bonus ID input
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for partner bonus ID
                    name: 'PartnerBonusId',
                    type: 'number', // Input type is number
                    label: _("<span class='icon-id'></span> ID"), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('ID'),
                    invalidMessage: _('ID is required'), // Validation message
                },
            ],
        };

        // Upper section containing all input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Columns for layout
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
